import { Editor } from '@tiptap/core'
import React, { createContext, useContext, useState } from 'react'

type EditorContextType = {
  editorInstance: Editor | null
  setEditorInstance: React.Dispatch<React.SetStateAction<Editor | null>>
}

const EditorContext = createContext<EditorContextType>(undefined)

export const EditorProvider = ({ children }: { children: React.ReactNode }) => {
  const [editorInstance, setEditorInstance] = useState<Editor | null>(null)

  return (
    <EditorContext.Provider
      value={{
        editorInstance,
        setEditorInstance,
      }}
    >
      {children}
    </EditorContext.Provider>
  )
}

export const useEditorContext = () => {
  const context = useContext(EditorContext)
  if (!context) throw new Error('useEditorContext must be used within a EditorProvider')
  return context
}
